import { SORT_OPTIONS } from "@/utils/applicationConstants";
import { sharedService } from "@/modules/shared/store/services/shared-service";
import { RECEIVE_GET_LENDER_CALL_LOG_STATUSES } from "@/redux/constants/lender_call_log_statuses";

const DEFAULT_FILTERS = { page: 1, size: 30, sortBy: SORT_OPTIONS[0].id, searchTerm: "" };

const getLenderCallLogStatuses = sharedService.injectEndpoints({
  endpoints: builder => ({
    getLenderCallLogStatuses: builder.query({
      query: () => {
        const params = new URLSearchParams();
        Object.entries(DEFAULT_FILTERS).forEach(([k, v]) => { if (v) params.set(k, v); });
        return `parameters/lender-call-log-statuses?${params}`;
      },
      transformResponse: response => response.items,
      providesTags: ["LenderCallLogStatuses"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch({ type: RECEIVE_GET_LENDER_CALL_LOG_STATUSES, lenderCallLogStatuses: data });
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetLenderCallLogStatusesQuery } = getLenderCallLogStatuses;

